<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="about-me">关于我</div>
      <div class="hint">你的联系方式</div> -->
      <img class="pic-about-me" src="https://static.huiyiji520.com/cppic-1661154078.png">
      <img class="pic-hint" src="https://static.huiyiji520.com/cppic-1661175802.png">
      <div class="row-contact flex-box">
        <!-- <div class="label-contact">微信号</div> -->
        <img class="pic-label-contact" src="https://static.huiyiji520.com/cppic-1661177298.png">
        <van-field class="input-contact wechat" v-model="wechat" placeholder="请输入微信号"/>
      </div>
      <div class="row-contact second flex-box">
        <!-- <div class="label-contact">手机号</div> -->
        <img class="pic-label-contact" src="https://static.huiyiji520.com/cppic-1661177311.png">
        <van-field class="input-contact phone" v-model="phone" type="digit" placeholder="请输入手机号"/>
      </div>
      <van-popup class="pop-confirm" v-model="showConfirm" round position="center" :close-on-click-overlay="false">
        <div>
          <div class="confirm-hint flex-box"><img class="pic-confirm-first" src="https://static.huiyiji520.com/cppic-1661177849.png">{{wechat}}</div>
          <div class="confirm-hint flex-box second"><img class="pic-confirm-second" src="https://static.huiyiji520.com/cppic-1661177868.png"></div>
          <div class="btns flex-box">
            <div class="btn confirm" @click="confirmWechat()">确认</div>
            <div class="btn cancel" @click="hidePopup()">返回修改</div>
          </div>
        </div>
      </van-popup>

      <div class="arrows" v-show="!showKeyboard">
        <div class="signs flex-box">
          <!-- <div class="prev" @click="goBack()"><van-icon name="arrow-left" color="#eb8e80" />上一步</div>
          <div class="next" @click="goNext()">下一步<van-icon name="arrow" color="#eb8e80" /></div> -->
          <img class="pic-prev" @click="goBack()" src="https://static.huiyiji520.com/cppic-1661159773.png">
          <img class="pic-next" @click="goNext()" src="https://static.huiyiji520.com/cppic-1661157292.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Icon, Field, Popup } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [Popup.name]: Popup
  },
  data(){
    return {
      phone: '',
      wechat: '',
      confirm: false,
      showConfirm: false,
      docmHeight: window.innerHeight, //默认屏幕高度
      showHeight: window.innerHeight, //实时屏幕高度
      showKeyboard: false
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goBack(){
      this.$router.back()
    },
    goNext(){
      if(this.wechat.trim().length < 1){
        Toast('请填写你的微信号')
      }else if(!this.phone){
        Toast('请填写你的手机号')
      }else if(!this.confirm){
        this.showConfirm = true
      }else{
        let cpchoose = this.$store.state.cpchoose
        cpchoose.myWechat = this.wechat
        cpchoose.myPhone = this.phone
        this.$store.commit('updateCpChoose', cpchoose)
        // this.handleRouter('/choose_partner_sex')
        this.handleRouter('/choose_partner_age')
      }
    },
    hidePopup(){
      this.showConfirm = false
    },
    confirmWechat(){
      this.confirm = true
      this.showConfirm = false
      this.goNext()
    },
    listenPageHeight(){
      window.addEventListener('resize', () => {
        this.showHeight = window.innerHeight
        if (this.docmHeight - this.showHeight > 100) {
          //Android系统: 软键盘弹出 隐藏footer
          this.showKeyboard = true
        } else {
          //Android系统: 软键盘收起 显示footer
          this.showKeyboard = false
        }
      })
    },
    recoverContact(){
      this.phone = this.$store.state.cpchoose.myPhone ? this.$store.state.cpchoose.myPhone : this.phone
      this.wechat = this.$store.state.cpchoose.myWechat ? this.$store.state.cpchoose.myWechat : this.wechat
    }
  },
  mounted(){
    this.recoverContact()
    this.listenPageHeight()
    this.$report.submit('/choose_me_contact', this.$store.state.issue, this.$store.state.userinfo.openid)
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url("https://static.huiyiji520.com/cppic-1661155471.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
.main .about-me{margin-top:200px;margin-bottom:134px;font-size:70px;color:#eb8e80;}
.main .hint{font-size:40px;line-height:40px;color:#eb8e80;margin-bottom:160px;}
.main .pic-about-me{width:206px;height:68px;margin:0 auto;margin-top:208px;margin-bottom:134px;}
.main .pic-hint{width:249px;height:41px;margin:0 auto;margin-bottom:160px;}
.main .row-contact{padding:0px 110px;font-size:40px;color:#737373;}
.main .row-contact.second{margin-top:98px;}
.main .row-contact .input-contact{
  margin-left:50px;font-size:32px;color:#eb8e80;background:#fff;
  border:2px dashed #eb8e80;padding:20px 20px;
}
.main .row-contact .label-contact{width:140px;flex-shrink:0;}
.main .row-contact .pic-label-contact{width:112px;height:37px;}
.main .pop-confirm{font-size:32px;color:#545454;width:80%;padding:50px;}
.main .pop-confirm .confirm-hint{justify-content:center;}
.main .pop-confirm .confirm-hint.second{margin-top:50px;margin-bottom:50px;justify-content:center;}
.main .pop-confirm .pic-confirm-first{width:184px;height:28px;margin-right:10px;}
.main .pop-confirm .pic-confirm-second{width:320px;height:31px;}
.main .pop-confirm .btns{justify-content:center;}
.main .pop-confirm .btns .btn{width:180px;border:2px solid #f1b8af;border-radius:30px;padding:10px 0px;}
.main .pop-confirm .btns .btn.confirm{margin-right:60px;color:#fff;background:#f1b8af;}
.main .pop-confirm .btns .btn.cancel{color:#eb8e80;}
/* .main .row-contact{
  font-size:40px;font-family:'NotoSerifSCBlack';color:#eb8e80;width:340px;
  background:#fff;border:1px dashed #eb8e80;height:86px;line-height:86px;margin:0px auto;
}
.main .row-contact.second{margin-top:98px;} */
.main .arrows{position: fixed;bottom:120px;width:100%;}
.main .arrows .signs{
  justify-content:space-between;padding:0px 194px;
  font-size:32px;color:#eb8e80;
}
.main .pic-prev{width:120px;height:32px;}
.main .pic-next{width:120px;height:32px;}
</style>
